module.exports = __webpack_public_path__ + "static/img/13.5112866.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/13.png
// module id = Z2ST
// module chunks = 0